import {Pipe, PipeTransform} from '@angular/core';
import {Meldung} from '../models/meldung';

@Pipe({
    name: 'meldung',
    standalone: false
})
export class MeldungPipe implements PipeTransform {

  private _klassifikationsMap: Map<string, number> = new Map(
      [['Annahmerichtlinie', 0],
        ['GeschaeftsplanBestimmung', 1],
        ['Standard', 2]]);

  transform(items: Meldung[], meldungskategorie: string, mostImportent?: boolean): Meldung[] {
    if (!items) {
      return [];
    }
    if(mostImportent) {
      return this.getMostImportantMeldung(items);
    }
    if (!meldungskategorie) {
      return items;
    }
    return items.filter(meldung => meldung.Meldungskategorie === (meldungskategorie))
      .sort((a,b) => {
          if(!!a.Meldungsklassifikation && !!b.Meldungsklassifikation){
            if(this._klassifikationsMap.get(a.Meldungsklassifikation) < this._klassifikationsMap.get(b.Meldungsklassifikation)){
              return -1;
            } else if(this._klassifikationsMap.get(a.Meldungsklassifikation) > this._klassifikationsMap.get(b.Meldungsklassifikation)){
              return 1;
            } else {
              return 0;
            }
          } else if(!!b.Meldungsklassifikation){
            return -1;
          }
          return 0;
      });
  }

  public getMostImportantMeldungstext(uiMeldung: Meldung[]): string{
    const meldung = this.getMostImportantMeldung(uiMeldung);
    return meldung[0].Meldungstext;
  }

  public getMostImportantMeldung(uiMeldung: Meldung[]): Meldung[]{
    let filteredMeldung = this.transform(uiMeldung, 'Fehler');
    if(filteredMeldung.length){
      return filteredMeldung;
    }
    filteredMeldung = this.transform(uiMeldung, 'Warnung');
    if(filteredMeldung.length){
      return filteredMeldung;
    }
    filteredMeldung = this.transform(uiMeldung, 'Info');
    if(filteredMeldung.length){
      return filteredMeldung;
    }
    return uiMeldung.slice(0,1);
  }

}
